<template>
  <nut-tabbar ref="tab" @tab-switch="tabSwitch" class="tab" :tabbar-list="tabList" :bottom="true"/>
</template>

<script>
//import index1 from '@/resource/img/index1.png'
//import index2 from '@/resource/img/index2.png'
import goods1 from '../../../../resource/img/tab/good1.png'
import goods2 from '../../../../resource/img/tab/good2.png'
import dt1 from '../../../../resource/img/tab/dt1.png'
import dt2 from '../../../../resource/img/tab/dt2.png'
import me1 from '../../../../resource/img/tab/me1.png'
import me2 from '../../../../resource/img/tab/me2.png'

/**
 * 底部导航栏 组件
 */
export default {
  name: 'MTab',
  props: {
    'index': {
      type: Number,
      default: 0,
    }
  },
  data () {
    return {
      tabList: [{
        'tabTitle': '首页',
        'curr': this.index == 0 ? true : false,
        'icon': goods1,
        'activeIcon': goods2,
        'href': null,
        'page': '/device/DeviceHome'
      }, {
        'tabTitle': '动态',
        'curr': this.index == 1 ? true : false,
        'icon': dt1,
        'activeIcon': dt2,
        'href': null,
        'page': '/device/DeviceDynamic'
      }, {
        'tabTitle': '我的',
        'curr': this.index == 2 ? true : false,
        'icon': me1,
        'activeIcon': me2,
        'href': null,
        'page': '/device/DeviceMy'
      }]
    }
  },
  mounted () {
    let tab = this.$refs.tab
    tab.currIndex = this.index
  },
  methods: {
    tabSwitch (val) {
      let tab = this.$refs.tab
      if (!val.curr) {
        tab.currIndex = this.index
        this.$router.replace(val.page)
      }
    }
  }
}
</script>

<style scoped>
  .tab {
    height: 50px;
  }

  >>> .icon-box .icon {
    width: 20px;
    height: 20px;
  }

  >>> .curr {
    color: #589FF5;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/comp/MTab/MTab.vue